// UI micro-copy. Section titles/descriptions come from the backend config so they
// stay data-driven; this only holds chrome/labels the frontend owns.
const en = {
  explore: "Explore", exploreAll: "Explore all", search: "Search",
  searchPlaceholder: "Search articles, recipes, exercises…",
  login: "Log in", logout: "Log out", register: "Sign up", dashboard: "Dashboard",
  admin: "Admin", account: "Account", signIn: "Sign in",
  navGoals: "Goals", navTools: "Tools", navLearn: "Learn", navProducts: "Products",
  getStarted: "Get started", readMore: "Read more", viewAll: "View all",
  relatedContent: "Related", loading: "Loading…", comingSoon: "Coming soon",
  notFound: "Page not found", backHome: "Back to home", noResults: "No results found.",
  resultsFor: "Results for",
  yourFocus: "Your focus", changeGoal: "Change", clearGoal: "Clear",
  calcResult: "Your result", calcEstimate: "This is an estimate, not medical advice.",
  calcRecalculate: "Recalculate", calcRelated: "Related on LIVYVIO", calcGoals: "Related goals",
  unitMetric: "Metric", unitImperial: "Imperial", calculate: "Calculate", saveResult: "Save result",
  // hero
  heroKicker: "Nutrition · Movement · Recovery",
  heroTitle: "Live better, every day.",
  heroTitleLead: "Live better,", heroTitleAccent: "every day.",
  heroSubtitle: "Practical nutrition, movement and wellness knowledge — made simple, for real life.",
  ctaExplore: "Explore LIVYVIO", ctaGoal: "Choose your goal",
  statCaption: "languages · scalable to many more",
  // goals
  goalsTitle: "What would you like to improve?",
  goalsSub: "Pick a direction and we'll point you to the right content.",
  goalLose: "Lose weight", goalMuscle: "Build muscle", goalEat: "Eat better",
  goalFit: "Get fit", goalPerf: "Improve performance", goalSleep: "Sleep better", goalFeel: "Feel better",
  // explore
  exploreTitle: "Explore LIVYVIO", exploreSub: "Everything you need for a healthier everyday.",
  // tools
  toolsTitle: "Useful tools for your body and goals",
  toolsSub: "Simple calculators to turn goals into numbers. Coming soon.",
  toolBmi: "BMI", toolCalories: "Daily calories", toolProtein: "Protein needs",
  toolHydration: "Hydration", toolMacros: "Macros",
  // featured
  featArticles: "Featured articles", featExercises: "Popular exercises", featRecipes: "Healthy recipes",
  // body
  bodyTitle: "Understand your body",
  bodySub: "LIVYVIO is more than workouts — learn how your body actually works.",
  bodyMuscles: "Muscles", bodyMetabolism: "Metabolism", bodyHydration: "Hydration",
  bodyRecovery: "Recovery", bodyEnergy: "Energy",
  // products
  productsTitle: "Products & recommendations",
  productsSub: "Independent, educational product info — one small part of the LIVYVIO ecosystem.",
  browseProducts: "Browse products",
  // newsletter
  newsTitle: "Better living, one useful idea at a time.",
  newsSub: "Occasional, practical wellness tips. No noise.",
  newsPlaceholder: "Your email", newsCta: "Subscribe",
  newsSuccess: "Thanks! You're subscribed.", newsError: "Something went wrong. Please try again.",
  // footer
  footerExplore: "Explore", footerGoals: "Goals", footerTools: "Tools", footerLearn: "Learn",
  footerCompany: "Company", about: "About LIVYVIO", contact: "Contact",
  privacy: "Privacy", cookies: "Cookies", terms: "Terms",
  healthDisclaimer: "Health disclaimer", affiliateDisclosure: "Affiliate disclosure",
  footerTagline: "A global platform for healthy living. Educational content — not medical advice.",
  footerLangs: "EN · ES · NL — more languages coming",
  // dashboard
  myFavorites: "My favorites", noFavorites: "You haven't saved anything yet.",
  premiumTitle: "LIVYVIO+ is coming", premiumBody: "Personalized plans and advanced tools — reserved for a future release.",
  saveFavorite: "Save", saved: "Saved", externalOffers: "Where to buy",
  externalNote: "LIVYVIO provides independent, educational information. Purchases happen on external, authorized platforms.",
  visitStore: "Visit store", affiliate: "Affiliate link", faq: "Frequently asked questions",
  email: "Email", password: "Password", name: "Name",
  // structured content labels
  keyTakeaways: "Key takeaways", sources: "Sources & references", onThisPage: "On this page",
  byAuthor: "By", updatedOn: "Updated", reviewedOn: "Reviewed", minRead: "min read",
  ingredients: "Ingredients", steps: "Steps", instructions: "Instructions", tips: "Tips",
  nutritionEstimate: "Estimated nutrition (per serving)", nutritionNote: "Values are estimates and vary by ingredients and portions.",
  prepTime: "Prep", cookTime: "Cook", totalTime: "Total", servings: "Servings", minutesShort: "min",
  difficulty: "Difficulty", mealTypes: "Meal types", dietaryTags: "Dietary", calories: "Calories",
  proteinLabel: "Protein", carbsLabel: "Carbs", fatLabel: "Fat", fiberLabel: "Fiber",
  primaryMuscles: "Primary muscles", secondaryMuscles: "Secondary muscles", equipment: "Equipment",
  movementType: "Movement", setsReps: "Suggested sets & reps", commonMistakes: "Common mistakes",
  coachingTips: "Coaching tips", safetyNote: "Safety note", alternatives: "Alternatives",
  howToTitle: "How to do it",
  healthDisclaimerBody: "This is educational content, not medical advice. Consult a qualified professional for personal guidance.",
  loadErrorTitle: "Couldn't load this page", loadErrorBody: "Something went wrong loading this content. Please try again.", retry: "Try again",
};

const es = {
  ...en,
  explore: "Explorar", exploreAll: "Explorar todo", search: "Buscar",
  searchPlaceholder: "Busca artículos, recetas, ejercicios…",
  login: "Iniciar sesión", logout: "Cerrar sesión", register: "Registrarse", dashboard: "Panel",
  admin: "Admin", account: "Cuenta", signIn: "Entrar",
  navGoals: "Objetivos", navTools: "Herramientas", navLearn: "Aprende", navProducts: "Productos",
  getStarted: "Empezar", readMore: "Leer más", viewAll: "Ver todo",
  relatedContent: "Relacionado", loading: "Cargando…", comingSoon: "Próximamente",
  notFound: "Página no encontrada", backHome: "Volver al inicio", noResults: "No se encontraron resultados.",
  resultsFor: "Resultados para",
  yourFocus: "Tu enfoque", changeGoal: "Cambiar", clearGoal: "Quitar",
  calcResult: "Tu resultado", calcEstimate: "Esto es una estimación, no consejo médico.",
  calcRecalculate: "Recalcular", calcRelated: "Relacionado en LIVYVIO", calcGoals: "Objetivos relacionados",
  unitMetric: "Métrico", unitImperial: "Imperial", calculate: "Calcular", saveResult: "Guardar resultado",
  heroKicker: "Nutrición · Movimiento · Recuperación",
  heroTitle: "Vive mejor, cada día.",
  heroTitleLead: "Vive mejor,", heroTitleAccent: "cada día.",
  heroSubtitle: "Conocimiento práctico de nutrición, movimiento y bienestar — simple, para la vida real.",
  ctaExplore: "Explorar LIVYVIO", ctaGoal: "Elige tu objetivo",
  statCaption: "idiomas · escalable a muchos más",
  goalsTitle: "¿Qué te gustaría mejorar?",
  goalsSub: "Elige una dirección y te llevamos al contenido adecuado.",
  goalLose: "Perder peso", goalMuscle: "Ganar músculo", goalEat: "Comer mejor",
  goalFit: "Ponerte en forma", goalPerf: "Mejorar rendimiento", goalSleep: "Dormir mejor", goalFeel: "Sentirte mejor",
  exploreTitle: "Explora LIVYVIO", exploreSub: "Todo lo que necesitas para un día a día más sano.",
  toolsTitle: "Herramientas útiles para tu cuerpo y tus objetivos",
  toolsSub: "Calculadoras simples para convertir objetivos en números. Próximamente.",
  toolBmi: "IMC", toolCalories: "Calorías diarias", toolProtein: "Proteína necesaria",
  toolHydration: "Hidratación", toolMacros: "Macros",
  featArticles: "Artículos destacados", featExercises: "Ejercicios populares", featRecipes: "Recetas saludables",
  bodyTitle: "Entiende tu cuerpo",
  bodySub: "LIVYVIO es más que entrenar — aprende cómo funciona tu cuerpo.",
  bodyMuscles: "Músculos", bodyMetabolism: "Metabolismo", bodyHydration: "Hidratación",
  bodyRecovery: "Recuperación", bodyEnergy: "Energía",
  productsTitle: "Productos y recomendaciones",
  productsSub: "Información de producto independiente y educativa — una pequeña parte del ecosistema LIVYVIO.",
  browseProducts: "Ver productos",
  newsTitle: "Vivir mejor, una buena idea a la vez.",
  newsSub: "Consejos de bienestar prácticos y ocasionales. Sin ruido.",
  newsPlaceholder: "Tu correo", newsCta: "Suscribirse",
  newsSuccess: "¡Gracias! Te has suscrito.", newsError: "Algo salió mal. Inténtalo de nuevo.",
  footerExplore: "Explorar", footerGoals: "Objetivos", footerTools: "Herramientas", footerLearn: "Aprende",
  footerCompany: "Empresa", about: "Sobre LIVYVIO", contact: "Contacto",
  privacy: "Privacidad", cookies: "Cookies", terms: "Términos",
  healthDisclaimer: "Aviso de salud", affiliateDisclosure: "Divulgación de afiliados",
  footerTagline: "Una plataforma global para la vida sana. Contenido educativo, no consejo médico.",
  footerLangs: "EN · ES · NL — más idiomas próximamente",
  myFavorites: "Mis favoritos", noFavorites: "Aún no has guardado nada.",
  premiumTitle: "LIVYVIO+ está en camino", premiumBody: "Planes personalizados y herramientas avanzadas — para una versión futura.",
  saveFavorite: "Guardar", saved: "Guardado", externalOffers: "Dónde comprar",
  externalNote: "LIVYVIO ofrece información independiente y educativa. Las compras se realizan en plataformas externas autorizadas.",
  visitStore: "Visitar tienda", affiliate: "Enlace de afiliado", faq: "Preguntas frecuentes",
  email: "Correo", password: "Contraseña", name: "Nombre",
  keyTakeaways: "Puntos clave", sources: "Fuentes y referencias", onThisPage: "En esta página",
  byAuthor: "Por", updatedOn: "Actualizado", reviewedOn: "Revisado", minRead: "min de lectura",
  ingredients: "Ingredientes", steps: "Pasos", instructions: "Instrucciones", tips: "Consejos",
  nutritionEstimate: "Nutrición estimada (por ración)", nutritionNote: "Los valores son estimaciones y varían según ingredientes y porciones.",
  prepTime: "Preparación", cookTime: "Cocción", totalTime: "Total", servings: "Raciones", minutesShort: "min",
  difficulty: "Dificultad", mealTypes: "Tipo de comida", dietaryTags: "Dieta", calories: "Calorías",
  proteinLabel: "Proteína", carbsLabel: "Carbohidratos", fatLabel: "Grasa", fiberLabel: "Fibra",
  primaryMuscles: "Músculos principales", secondaryMuscles: "Músculos secundarios", equipment: "Equipo",
  movementType: "Movimiento", setsReps: "Series y repeticiones sugeridas", commonMistakes: "Errores comunes",
  coachingTips: "Consejos de técnica", safetyNote: "Nota de seguridad", alternatives: "Alternativas",
  howToTitle: "Cómo hacerlo",
  healthDisclaimerBody: "Este es contenido educativo, no consejo médico. Consulta a un profesional cualificado para orientación personal.",
  loadErrorTitle: "No se pudo cargar esta página", loadErrorBody: "Algo salió mal al cargar este contenido. Inténtalo de nuevo.", retry: "Reintentar",
};

const nl = {
  ...en,
  explore: "Ontdek", exploreAll: "Alles ontdekken", search: "Zoeken",
  searchPlaceholder: "Zoek artikelen, recepten, oefeningen…",
  login: "Inloggen", logout: "Uitloggen", register: "Aanmelden", dashboard: "Dashboard",
  admin: "Beheer", account: "Account", signIn: "Inloggen",
  navGoals: "Doelen", navTools: "Tools", navLearn: "Leren", navProducts: "Producten",
  getStarted: "Beginnen", readMore: "Lees meer", viewAll: "Bekijk alles",
  relatedContent: "Gerelateerd", loading: "Laden…", comingSoon: "Binnenkort",
  notFound: "Pagina niet gevonden", backHome: "Terug naar home", noResults: "Geen resultaten gevonden.",
  resultsFor: "Resultaten voor",
  yourFocus: "Jouw focus", changeGoal: "Wijzigen", clearGoal: "Wissen",
  calcResult: "Jouw resultaat", calcEstimate: "Dit is een schatting, geen medisch advies.",
  calcRecalculate: "Herbereken", calcRelated: "Gerelateerd op LIVYVIO", calcGoals: "Gerelateerde doelen",
  unitMetric: "Metrisch", unitImperial: "Imperiaal", calculate: "Bereken", saveResult: "Resultaat opslaan",
  heroKicker: "Voeding · Beweging · Herstel",
  heroTitle: "Elke dag beter leven.",
  heroTitleLead: "Elke dag", heroTitleAccent: "beter leven.",
  heroSubtitle: "Praktische kennis over voeding, beweging en welzijn — simpel, voor het echte leven.",
  ctaExplore: "Ontdek LIVYVIO", ctaGoal: "Kies je doel",
  statCaption: "talen · schaalbaar naar veel meer",
  goalsTitle: "Wat wil je verbeteren?",
  goalsSub: "Kies een richting en wij wijzen je naar de juiste content.",
  goalLose: "Afvallen", goalMuscle: "Spieren opbouwen", goalEat: "Beter eten",
  goalFit: "Fit worden", goalPerf: "Prestaties verbeteren", goalSleep: "Beter slapen", goalFeel: "Je beter voelen",
  exploreTitle: "Ontdek LIVYVIO", exploreSub: "Alles voor een gezonder dagelijks leven.",
  toolsTitle: "Handige tools voor je lichaam en doelen",
  toolsSub: "Simpele rekenmachines om doelen in getallen om te zetten. Binnenkort.",
  toolBmi: "BMI", toolCalories: "Dagelijkse calorieën", toolProtein: "Eiwitbehoefte",
  toolHydration: "Hydratatie", toolMacros: "Macro's",
  featArticles: "Uitgelichte artikelen", featExercises: "Populaire oefeningen", featRecipes: "Gezonde recepten",
  bodyTitle: "Begrijp je lichaam",
  bodySub: "LIVYVIO is meer dan work-outs — leer hoe je lichaam echt werkt.",
  bodyMuscles: "Spieren", bodyMetabolism: "Metabolisme", bodyHydration: "Hydratatie",
  bodyRecovery: "Herstel", bodyEnergy: "Energie",
  productsTitle: "Producten & aanbevelingen",
  productsSub: "Onafhankelijke, educatieve productinfo — één klein deel van het LIVYVIO-ecosysteem.",
  browseProducts: "Bekijk producten",
  newsTitle: "Beter leven, één nuttig idee per keer.",
  newsSub: "Af en toe praktische welzijnstips. Geen ruis.",
  newsPlaceholder: "Je e-mail", newsCta: "Abonneren",
  newsSuccess: "Bedankt! Je bent geabonneerd.", newsError: "Er ging iets mis. Probeer het opnieuw.",
  footerExplore: "Ontdek", footerGoals: "Doelen", footerTools: "Tools", footerLearn: "Leren",
  footerCompany: "Bedrijf", about: "Over LIVYVIO", contact: "Contact",
  privacy: "Privacy", cookies: "Cookies", terms: "Voorwaarden",
  healthDisclaimer: "Gezondheidsdisclaimer", affiliateDisclosure: "Affiliate-vermelding",
  footerTagline: "Een wereldwijd platform voor gezond leven. Educatieve content — geen medisch advies.",
  footerLangs: "EN · ES · NL — meer talen binnenkort",
  myFavorites: "Mijn favorieten", noFavorites: "Je hebt nog niets opgeslagen.",
  premiumTitle: "LIVYVIO+ komt eraan", premiumBody: "Gepersonaliseerde plannen en geavanceerde tools — voor een toekomstige release.",
  saveFavorite: "Opslaan", saved: "Opgeslagen", externalOffers: "Waar te koop",
  externalNote: "LIVYVIO biedt onafhankelijke, educatieve informatie. Aankopen vinden plaats op externe, geautoriseerde platforms.",
  visitStore: "Bezoek winkel", affiliate: "Affiliate-link", faq: "Veelgestelde vragen",
  email: "E-mail", password: "Wachtwoord", name: "Naam",
  keyTakeaways: "Belangrijkste punten", sources: "Bronnen & referenties", onThisPage: "Op deze pagina",
  byAuthor: "Door", updatedOn: "Bijgewerkt", reviewedOn: "Beoordeeld", minRead: "min leestijd",
  ingredients: "Ingrediënten", steps: "Stappen", instructions: "Instructies", tips: "Tips",
  nutritionEstimate: "Geschatte voedingswaarde (per portie)", nutritionNote: "Waarden zijn schattingen en variëren per ingrediënt en portie.",
  prepTime: "Voorbereiding", cookTime: "Bereiding", totalTime: "Totaal", servings: "Porties", minutesShort: "min",
  difficulty: "Niveau", mealTypes: "Maaltijdtype", dietaryTags: "Dieet", calories: "Calorieën",
  proteinLabel: "Eiwit", carbsLabel: "Koolhydraten", fatLabel: "Vet", fiberLabel: "Vezels",
  primaryMuscles: "Primaire spieren", secondaryMuscles: "Secundaire spieren", equipment: "Materiaal",
  movementType: "Beweging", setsReps: "Aanbevolen sets & herhalingen", commonMistakes: "Veelgemaakte fouten",
  coachingTips: "Coaching-tips", safetyNote: "Veiligheidsnotitie", alternatives: "Alternatieven",
  howToTitle: "Zo doe je het",
  healthDisclaimerBody: "Dit is educatieve content, geen medisch advies. Raadpleeg een gekwalificeerde professional voor persoonlijk advies.",
  loadErrorTitle: "Kon deze pagina niet laden", loadErrorBody: "Er ging iets mis bij het laden van deze content. Probeer het opnieuw.", retry: "Opnieuw proberen",
};

export const strings = { en, es, nl };
export const SUPPORTED_LOCALES = ["en", "es", "nl"];
export const DEFAULT_LOCALE = "en";
